import { render, staticRenderFns } from "./copy-column.vue?vue&type=template&id=6a8e8975&scoped=true"
import script from "./copy-column.vue?vue&type=script&lang=js"
export * from "./copy-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e8975",
  null
  
)

export default component.exports